import React from 'react';
import { Content } from './shared';

const UniversalMammogram = () => (
  <Content>
    Mammogram screenings may help detect breast cancer. Ask your primary care physician if you
    qualify.
  </Content>
);

export default UniversalMammogram;
